import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
/**
 * This service contains all the static mappings for the application.
 * It is not the central data store and does not manage the application state.
 * 
 * The service includes error messages, regular expressions for validation, 
 * API service URLs, and environment-specific configurations.
 */
export class AppDictionaryService {

    // This service contains all the static mappings.
    //  This is not the central data store and hence, does not store the application state.
    /**
    * Error messages used throughout the application.
    */
    errorMessages = {
        serviceFailure: 'Our apologies, this site is experiencing some technical difficulties. Please refresh the page or try again.',
        validation: {
            percentage: 'Enter a percentage with max 2 decimal places.'
        }
    };
    /**
     * Regular expressions used for validating input data.
     */
    regexes = {
        percentage: /^(\d{1,3})(\.\d{1,2})?$/
    };
    /**
     * Service URLs for different API endpoints.
     * These are used to construct the complete API paths.
     */
    serviceUrls: { [key: string]: string } = {
        'login': 'loginservice',
        'file_download': 'file_download',
        'file_upload': 'io/upload/csv/bpx-000',
        'table_row_add': 'table_row_add',
        'table_row_edit': 'table_row_edit'
    };

    // Mapping website host with API host
    /**
    * A mapping of the website host to the respective API host.
    * Used for directing API requests to the correct environment.
    */
    apiHosts: { [key: string]: string } = {
        'localhost': 'localhost:8000',
        'dummyhost': 'dummyhost:8080/AppName/'
    };

    // Mapping website host with environment if needed by the API
    /**
    * A mapping of website hosts to the environment (e.g., DEV, PROD).
    * Used for API environment configuration.
    */
    environmentMapping = {
        'localhost': 'DEV'
    };

    /**
    * Settings related to the application, including the API host configuration.
    */
    settings = {
        apiFullHostName: document.location.origin + '/assets/JSONs/'
    };

    constructor() {
        // For our sample application here, we have simply considered any environment
        // setting "dummy_JSONs" to use the JSON files instead of backend API
        if (!environment.dummy_JSONs) {
            const apiHost = this.apiHosts[document.location.hostname];
            // The API application name wil be as per the backend host
            this.settings.apiFullHostName = document.location.protocol + "//" + apiHost;
        }
    }

    /**
    * Constructs the full URL for a given API path by combining the base API URL 
    * from the environment and the specified API path.
    * 
    * @param apiPath The path of the API endpoint to be called.
    * @returns The full API URL.
    */
    getAPI(apiPath: string) {
        const completeUrl = environment.apiBaseUrl + apiPath;
        return completeUrl;
    }
}
